"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CalendlyScriptProvider = exports.CalendlyScriptContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var CalendlyScriptContext = /*#__PURE__*/_react["default"].createContext({});

exports.CalendlyScriptContext = CalendlyScriptContext;

var CalendlyScriptProvider = function CalendlyScriptProvider(_ref) {
  var children = _ref.children;

  var scriptInjected = _react["default"].useRef(false);

  var addCalendlyScript = _react["default"].useCallback(function () {
    if (scriptInjected.current) return;
    var scriptTag = document.createElement('script');
    var linkTag = document.createElement('link');
    scriptTag.src = 'https://assets.calendly.com/assets/external/widget.js';
    scriptTag.type = 'text/javascript';
    linkTag.rel = 'stylesheet';
    linkTag.href = 'https://assets.calendly.com/assets/external/widget.css';
    document.getElementsByTagName('body')[0].appendChild(scriptTag);
    document.getElementsByTagName('head')[0].appendChild(linkTag);
  }, []);

  var engageScript = _react["default"].useCallback(function () {
    addCalendlyScript();
    scriptInjected.current = true;
  }, [addCalendlyScript]);

  return /*#__PURE__*/_react["default"].createElement(CalendlyScriptContext.Provider, {
    value: engageScript
  }, children);
};

exports.CalendlyScriptProvider = CalendlyScriptProvider;
CalendlyScriptProvider.propTypes = {
  children: _propTypes["default"].node
};

var CalendlyScriptHOC = function CalendlyScriptHOC(WrappedComponent) {
  var CalendlyScript = function CalendlyScript(props) {
    return /*#__PURE__*/_react["default"].createElement(CalendlyScriptContext.Consumer, null, function (calendlyEngageScript) {
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, props, {
        calendlyEngageScript: calendlyEngageScript
      }));
    });
  };

  CalendlyScript.propTypes = {
    children: _propTypes["default"].node
  };
  CalendlyScript.displayName = "CalendlyScript(".concat(WrappedComponent.displayName || 'Component', ")");
  return /*#__PURE__*/(0, _react.memo)(CalendlyScript);
};

var _default = CalendlyScriptHOC;
exports["default"] = _default;